export default __webpack_public_path__ + "static/seo_sales-estimator-9e4059734832a21363d69e0508f6192b.png";